jQuery(function ($) {
	$(".wp-block-haus-search-menu-link > a").on("click", function (event) {
		event.preventDefault();
		$(this)
			.parent()
			.find(".haus-search-link-input-wrapper")
			.toggleClass("active");
	});
	$(document).click(function (event) {
		var $target = $(event.target);
		if (
			!$target.closest(".wp-block-haus-search-menu-link").length &&
			$(".haus-search-link-input-wrapper").hasClass("active")
		) {
			$(".haus-search-link-input-wrapper").removeClass("active");
		}
	});
});
